import { Localization } from "OW.Remoting/Remoting/Localization";
import { DateTimeFormatObject, DateUtils } from "../../../../Global/Base/Utils/DateUtils";
import { CultureInfo } from "../../../../Global/Dom/CultureInfo";
import { ControlParams } from "./ControlInterfaces";
import { DateEditsParent } from "./DateEditsParent";

export class DateEdit extends DateEditsParent {
    //#region Fields
    //#region Localizations
    //private static _currentText: string;
    //private static _closeText: string;
    //#endregion Localizations
    /**Pomocná proměnná, pokud proběhne inicializace statických prvků, nastaví se true*/
    private static _initialized = false;
    private static _fmtFunc: DateTimeFormatObject;
    // @ts-ignore // 23.4.2018 nečteno, ale prozatím ponecháno
    private static _culture: string; // jmeno kultury
    private static _fmtRe = /(d+|m+|y+)([^dmy]+)(d+|m+|y+)([^dmy]+)(d+|m+|y+)([^dmy]*)/i; //  regex ktery z ShortDate formatu izoluje oddelovace + format dnu/mesicu (d nebo dd)
    private static _dateinputRe = /^(\d{4})-(\d{1,2})-(\d{1,2})$/; // regex pro input typu date, ten vraci vzdy ve formatu yyyy-mm-dd
    // regexy, vraci 6 skupin - 1. je den, 2. a 3. je mesic a den (v lib. poradi), 4. 5. a 6. jsou den, mesic a rok podle poradi v aktualni kulture
    private static _noSepDmy = /^(?:(\d{1,2})|(\d{2})(\d{2})|(\d{2})(\d{2})(\d{2}|\d{4}))$/; // d | dm | dmy
    private static _noSepDym = /^(?:(\d{1,2})|(\d{2})(\d{2})|(\d{2})(\d{2}|\d{4})(\d{2}))$/; // d | dm | dym
    private static _noSepYmd = /^(?:(\d{1,2})|(\d{2})(\d{2})|(\d{2}|\d{4})(\d{2})(\d{2}))$/; // d | dm | ymd
    private static _sepDmy = /^(?:(\d{1,2})[^\d]*|(\d{1,2})[^\d]+(\d{1,2})[^\d]*|(\d{1,2})[^\d]+(\d{1,2})[^\d]+(\d{2}|\d{4})[^\d]*)$/; // d. | d.m. | d.m.y.
    private static _sepDym = /^(?:(\d{1,2})[^\d]*|(\d{1,2})[^\d]+(\d{1,2})[^\d]*|(\d{1,2})[^\d]+(\d{2}|\d{4})[^\d]+(\d{1,2})[^\d]*)$/; // d. | d.m. | d.y.m.
    private static _sepYmd = /^(?:(\d{1,2})[^\d]*|(\d{1,2})[^\d]+(\d{1,2})[^\d]*|(\d{2}|\d{4})[^\d]+(\d{1,2})[^\d]+(\d{1,2})[^\d]*)$/; // d. | d.m. | y.m.d.

    private static _fmtOrder: string; // TODO: udelat z toho static? (+ prislusne metody)

    //Listeners
    private _listenerFakeChange: EventListener;
    private _listenerFakeFocus: EventListener;
    private _listenerFakeBlur: EventListener;
    private _listenerPickerClick: EventListener;
    private _listenerFocus: EventListener;
    private _listenerBlur: EventListener;
    private _listenerChange: EventListener;

    protected _originValue: Date;
    //#endregion Fields

    //#region Properties

    //#region Control Value
    /**vraci javascript Date*/
    public override get controlValue(): any /*Date*/ {
        if (!this._fakeInput.value)
            return null;
        const val = DateEdit._dateinputRe.exec(this._fakeInput.value);
        if (!val || !DateEdit.checkDate(+val[1], +val[2], +val[3]))
            return null;

        let result = new Date(+val[1], (+val[2]) - 1, +val[3], 0, 0, 0);
        if (this._originValue)
            result = DateUtils.unionDateAndTime(result, this._originValue);
        return result;
    }

    /**vstupuje sem OWDate nebo js Date, pokud je pouzito pro typ DateTime z DB/AS*/
    public override set controlValue(val: any /*OWDate nebo js Date */) {
        if (val !== undefined && val !== null && val instanceof Date) {
            this._originValue = val;
            this._formatDateAndSetValues(val.getFullYear(), (val.getMonth() + 1), val.getDate(), false);
        } else {
            this._originValue = null;
            this._fakeInput.value = "";
            this.innerElement.value = "";
            this.setValid();
        }
    }
    //#endregion Control Value

    //#endregion Properties

    //#region Constructors
    constructor(params: ControlParams) {
        super(params);
        this.element.classList.add("DateEdit");

        this._setListeners();

        //this.Culture = "en-GB";
        if (this.culture) {
            DateEdit._fmtFunc = DateUtils.getDateToStringFunction("d", this.culture);
            this.controlValue = this.controlValue;
        }

        this.cultureChanged.add((_s, e) => {
            DateEdit._fmtFunc = DateUtils.getDateToStringFunction("d", e);
            this.controlValue = this.controlValue;
        });
    }
    //#endregion Constructors

    //#region Methods

    public override validate(): boolean {
        if (this.innerElement.value) {
            this.parseAndValidateUserInput(false);
        } else if (!this._fakeInput.value) {
            this.setValid();
        } else {
            const val = DateEdit._dateinputRe.exec(this._fakeInput.value);
            if (!(!!val && DateEdit.checkDate(+val[1], +val[2], +val[3])))
                this._showError();
            else
                this.setValid();
        }
        return this.isValid;
    }

    //#region Must implement from DateEditParents

    /**Volano z predka*/
    public override initStaticFields(): void {
        if (DateEdit._initialized)
            return;

        DateEdit._fmtFunc = DateUtils.getDateToStringFunction("d");
        DateEdit._culture = CultureInfo.getCultureInfo().name;

        DateEdit.initFmtOrder(); // nastaveni aktualniho formatu data

        ////aktualni datum (dnes)/ hotovo
        //Localization.getLocalizationItem('GUI-247263').then((loc) => { // Dnes
        //    if (loc != null)
        //        DateEdit._currentText = loc.Text;
        //});

        ////aktualni datum (dnes)/ hotovo
        //Localization.getLocalizationItem('SRC-6133').then((loc) => { // Hotovo
        //    if (loc != null)
        //        DateEdit._closeText = loc.Text;
        //});

        /*
        Localization.LoadLocalizations(['GUI-247263', 'SRC-6133', 'XXX-1245']).then((locKeys) => {
            var x = locKeys[0];
            var y = locKeys[1];
            var z = locKeys[2];
        });*/

        DateEdit._initialized = true;
    }

    public static override createFakeInput(): HTMLInputElement {
        return DateEditsParent.createNormalFakeInput();
    }

    public static createCalPicker(): HTMLElement {
        return null;
    }

    public override setOtherProperties(): void {
        this.innerElement.type = "tel";
        this.innerElement.maxLength = 20;
    }

    public override composeElements(): void {
        this._fakeInput.type = "date";
        this.composeForNativeWithFake();
    }
    //#endregion Inherited from DateEditParents

    /**nastavi format data podle aktualni lokalizace*/
    public static initFmtOrder(): void {
        const res = DateEdit._fmtRe.exec(CultureInfo.getStandardDateTimeFormat("d"));
        DateEdit._fmtOrder = "";
        for (let i = 1; i < 6; i += 2) {
            if (/d/i.test(res[i])) {
                DateEdit._fmtOrder += "d";
            } else if (/m/i.test(res[i])) {
                DateEdit._fmtOrder += "m";
            } else if (/y/i.test(res[i])) {
                DateEdit._fmtOrder += "y";
            }
        }
    }

    private _setListeners(): void {
        this._fakeInput.addEventListener("change", this._listenerFakeChange = () => {
            this.innerElement.value = DateEdit._formatDate(this._fakeInput.value);
            this.setValid();
            this.valueChanged.trigger(this, { Sender: this });
        });

        this._fakeInput.addEventListener("focus", this._listenerFakeFocus = (e: FocusEvent) => {
            this.getFocus.trigger(this, e);
            this._onfocus();
        });

        this._fakeInput.addEventListener("blur", this._listenerFakeBlur = (e: FocusEvent) => {
            this.lostFocus.trigger(this, e);
            this._onblur();
        });

        this.innerElement.addEventListener("focus", this._listenerFocus = (e: FocusEvent) => {
            this.getFocus.trigger(this, e);
            this._onfocus();
        });

        this.innerElement.addEventListener("blur", this._listenerBlur = (e: FocusEvent) => {
            this.lostFocus.trigger(this, e);
            this._onblur();
        });

        this.innerElement.addEventListener("change", this._listenerChange = () => {
            this.parseAndValidateUserInput(true);
        });

        this._calPicker.addEventListener("click", this._listenerPickerClick = () => {
            (this._fakeInput as any).showPicker();
        });
    }

    private _onfocus(): void {
        if (this.enabled) {
            this.element.classList.add("focused");
            if (this.isValid)
                this.innerElement.value = DateEdit._formatDate(this._fakeInput.value); // zformatuje v aktualni kulture
        }
    }

    private _onblur(): void {
        this.element.classList.remove("focused");
    }

    //// nacte datepicker, nasetuje nazvy dnu a mesicu podle aktualni kultury
    //private setDatepicker() {
    //    var culture = CultureInfo.GetCultureInfo();
    //    $(this.fakeInput).datepicker({
    //        //localization
    //        currentText: DateEdit.currentText,
    //        closeText: DateEdit.closeText,
    //        //setings
    //        dateFormat: 'yy-mm-dd', // nasetuje stejny format jako vraci input typu date, abych mohl vyuzit uz hotovou fci
    //        onSelect: (dateText: string) => {
    //            this.InnerElement.value = DateEdit.formatDate(dateText);
    //            this.SetValid();
    //            this.ValueChanged.trigger(this, { Sender: this });
    //        },
    //        //monthNames: culture.DateTimeFormat.MonthNames.map((val) => {
    //        //    return val[0].toLocaleUpperCase() + val.slice(1);
    //        //}),
    //        monthNamesShort: culture.DateTimeFormat.AbbreviatedMonthNames.map((val) => {
    //            return val[0].toLocaleUpperCase() + val.slice(1);
    //        }),
    //        dayNamesMin: culture.DateTimeFormat.AbbreviatedDayNames.map((val) => {
    //            return val[0].toLocaleUpperCase() + val.slice(1);
    //        }),
    //        changeMonth: true,
    //        changeYear: true,
    //        showButtonPanel: true,
    //        yearRange: "-50:+10"
    //    });
    //}

    // ziska datum z uzivatelem psaneho textu, zvaliduje, zformatuje
    public parseAndValidateUserInput(triggerEvent: boolean): void {
        let val = this.innerElement.value;
        if (!val) {
            this._fakeInput.value = this.innerElement.value = "";
            this.setValid();
            this.valueChanged.trigger(this, { Sender: this });
            return;
        }

        val = val.replace(/\u200E/g, ""); //Unicode Character 'LEFT-TO-RIGHT MARK' - je vlozen pred kazdym cislem po zavolanim Date.toLocaleString

        const rexes = DateEdit._getRexes(); // ziskani regexu
        const res: RegExpExecArray = rexes.noSep.exec(val) || rexes.sep.exec(val); // zkontrolovani data

        if (val && !res) { // nevalidni format data
            this._showError();
            return;
        }

        if (res[1]) { // zadan den
            const today = new Date();
            this._formatDateAndSetValues(today.getFullYear(), today.getMonth() + 1, +res[1], triggerEvent);
        } else if (res[2]) { // zadan den a mesic
            const today = new Date();
            const dayBeforeMon = DateEdit._fmtOrder.indexOf("d") < DateEdit._fmtOrder.indexOf("m");
            if (dayBeforeMon) { // den pred mesicem
                this._formatDateAndSetValues(today.getFullYear(), +res[3], +res[2], triggerEvent);
            } else { // mesic pred dnem
                this._formatDateAndSetValues(today.getFullYear(), +res[2], +res[3], triggerEvent);
            }
        } else if (res[4]) { // zadan rok, mesic, den
            const y = DateEdit._fmtOrder.indexOf("y");
            const m = DateEdit._fmtOrder.indexOf("m");
            const d = DateEdit._fmtOrder.indexOf("d");
            const yr = res[y + 4].length == 2 ? "20" + res[y + 4] : res[y + 4]; // doplneni roku o 20
            this._formatDateAndSetValues(+yr, +res[m + 4], +res[d + 4], triggerEvent);
        }
    }

    // vrati regexy pro ziskani data
    private static _getRexes(): { noSep: RegExp; sep: RegExp } {
        if (DateEdit._fmtOrder.indexOf("y") == 2)
            return { noSep: DateEdit._noSepDmy, sep: DateEdit._sepDmy };
        else if (DateEdit._fmtOrder.indexOf("y") == 1)
            return { noSep: DateEdit._noSepDym, sep: DateEdit._sepDym };
        else
            return { noSep: DateEdit._noSepYmd, sep: DateEdit._sepYmd };
    }

    // propojeni mezi datepickerem/nativnim kalendarem a tel inputem. Bere format stejny jako fce formatDate
    private _formatDateAndSetValues(year: number, mon: number, day: number, userChange: boolean): boolean {
        if (!DateEdit.checkDate(year, mon, day)) {
            this._showError();
            return false;
        }

        const val = year + "-" + DateEdit._addZero(mon + "") + "-" + DateEdit._addZero(day + "");
        this._fakeInput.value = val;
        this.innerElement.value = DateEdit._formatDate(val);

        this.setValid();

        if (userChange)
            this.valueChanged.trigger(this, { Sender: this });

        return true;
    }

    // formatuje retezec (vzdy ve forme yyyy-m(m)-d(d) (napr. 2014-02-25 n. 2014-2-5))
    // vraci jej zformatovany podle aktualni kultury nebo prazdny, pokud format neni rozpoznan
    private static _formatDate(date: string): string {
        if (!date)
            return "";

        return DateEdit._fmtFunc.format(new Date(date));
    }

    // zkontroluje, jestli zadany den/mesic/rok tvori platne datum
    public static checkDate(year: number, mon: number, day: number): boolean {
        const date = new Date(year, mon - 1, day);
        return date.getFullYear() == year && date.getMonth() == mon - 1 && date.getDate() == day;
    }

    // prida pocatecni nulu ke dni/mesici
    private static _addZero(val: string): string {
        if (val.length == 1)
            return "0" + val;
        return val;
    }

    private _showError(): void {
        this.setInvalid("GUI-502861"); //Nemohli jsme rozpoznat zadane datum.
    }

    protected override _createValuePicker(): HTMLElement {
        const picker = super._createValuePicker();
        Localization.addLocData(picker, "GUI-798917", ["title", "ariaLabel"]); // Výběr z kalendáře
        return picker;
    }
    //#endregion Methods

    //destruktor
    public override dispose(): void {
        if (this._fakeInput) {
            this._fakeInput.removeEventListener("change", this._listenerFakeChange);
            this._fakeInput.removeEventListener("focus", this._listenerFakeFocus);
            this._fakeInput.removeEventListener("blur", this._listenerFakeBlur);
        }

        if (this.innerElement) {
            this.innerElement.removeEventListener("focus", this._listenerFocus);
            this.innerElement.removeEventListener("blur", this._listenerBlur);
            this.innerElement.removeEventListener("change", this._listenerChange);
        }

        if (this._calPicker)
            this._calPicker.removeEventListener("click", this._listenerPickerClick);

        super.dispose();
    }
}
//declare module JQueryUI {
//    interface Datepicker {
//        _gotoToday: (id: string) => void;
//        _attachHandlers: (inst: any) => void;
//    }
//}

//// prizpusobeni datepickeru
//// http://stackoverflow.com/questions/1073410/today-button-in-jquery-datepicker-doesnt-work
//if ($ && $.datepicker) {
//    // vyber data pri kliknuti na 'Dnes'
//    //var old_gotoToday = $.datepicker._gotoToday;
//    //$.datepicker._gotoToday = function (id: string) {
//    //    old_gotoToday.call(this, id);
//    //    this._selectDate(id);
//    //}
//    // lokalizace Today a Done pri klikani na sipky/selecty (pri kliku se cely obsah pickeru prepise, tim padem se musi vzdy updatovat lockeys)
//    var old_attachHandlers = $.datepicker._attachHandlers;
//    $.datepicker._attachHandlers = function (inst: any) {
//        old_attachHandlers.call(this, inst);
//        /*var loc = UI.Controls.DateEdit.setLoc;
//        $('.ui-datepicker-prev').bind('click', loc);
//        $('.ui-datepicker-next').bind('click', loc);
//        $('.ui-datepicker-month').bind('change', loc);
//        $('.ui-datepicker-year').bind('change', loc);
//*/
//    }
//}
